// extracted by mini-css-extract-plugin
export var bar = "Control-module--bar--c7991";
export var blink = "Control-module--blink--32918";
export var close = "Control-module--close--5e731";
export var description = "Control-module--description--95acb";
export var gradient = "Control-module--gradient--2af8b";
export var run = "Control-module--run--a978f";
export var spin = "Control-module--spin--bb31f";
export var title = "Control-module--title--a9a5a";
export var verb = "Control-module--verb--665b5";